module.exports = __webpack_public_path__ + "static/img/withdraw.6c170a7e.png";